// extracted by mini-css-extract-plugin
export default {"signinPage":"SigninPage_signinPage__8wOwL","signinBlock":"SigninPage_signinBlock__d-+ES"};